var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":"/auth/login"}},[_vm._v("Sign In")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }